import { IAppState } from '../../../AppModulesWrapper';

export const selectTotalBalance = (state: IAppState): number => {
  return state.servicePickerWidget.balance.totalBalance;
};
